import React, { createContext, useState, useContext, useEffect } from 'react';

const WatchHistoryContext = createContext();

export const useWatchHistory = () => {
  const context = useContext(WatchHistoryContext);
  if (!context) {
    throw new Error('useWatchHistory must be used within a WatchHistoryProvider');
  }
  return context;
};

export const WatchHistoryProvider = ({ children }) => {
  // 从本地存储加载观看历史
  const [watchHistory, setWatchHistory] = useState(() => {
    try {
      const storedHistory = localStorage.getItem('watchHistory');
      return storedHistory ? JSON.parse(storedHistory) : [];
    } catch (error) {
      console.error('Failed to load watch history from localStorage:', error);
      return [];
    }
  });

  // 保存观看历史到本地存储
  useEffect(() => {
    try {
      localStorage.setItem('watchHistory', JSON.stringify(watchHistory));
    } catch (error) {
      console.error('Failed to save watch history to localStorage:', error);
    }
  }, [watchHistory]);

  // 添加到观看历史
  const addToWatchHistory = (drama) => {
    // 创建观看记录
    const watchRecord = {
      id: drama.id,
      title: drama.name || drama.title,
      poster: drama.poster,
      category: drama.category || "未分类",
      views: drama.viewCount || 0,
      watchTime: new Date().toISOString(),
    };

    // 检查是否已存在该剧集的记录
    const existingIndex = watchHistory.findIndex(item => item.id === drama.id);
    
    if (existingIndex !== -1) {
      // 如果已存在，更新观看时间
      const newHistory = [...watchHistory];
      newHistory[existingIndex] = {
        ...newHistory[existingIndex],
        watchTime: watchRecord.watchTime,
      };
      setWatchHistory(newHistory);
    } else {
      // 如果不存在，添加到历史记录（保留最近100条）
      const newHistory = [watchRecord, ...watchHistory].slice(0, 100);
      setWatchHistory(newHistory);
    }
    
    console.log('剧集已添加到观看历史:', watchRecord.title);
  };

  // 从观看历史中移除
  const removeFromWatchHistory = (dramaId) => {
    setWatchHistory(prev => prev.filter(item => item.id !== dramaId));
    console.log('剧集已从观看历史中移除:', dramaId);
  };

  // 清空观看历史
  const clearWatchHistory = () => {
    setWatchHistory([]);
    console.log('观看历史已清空');
  };

  // 获取观看历史
  const getWatchHistory = () => {
    return watchHistory.sort((a, b) => new Date(b.watchTime) - new Date(a.watchTime));
  };

  // 获取观看历史数量
  const getWatchHistoryCount = () => {
    return watchHistory.length;
  };

  // 检查剧集是否在观看历史中
  const isInWatchHistory = (dramaId) => {
    return watchHistory.some(item => item.id === dramaId);
  };

  const value = {
    watchHistory: getWatchHistory(),
    addToWatchHistory,
    removeFromWatchHistory,
    clearWatchHistory,
    getWatchHistoryCount,
    isInWatchHistory,
  };

  return (
    <WatchHistoryContext.Provider value={value}>
      {children}
    </WatchHistoryContext.Provider>
  );
};